import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="documents--due-date-setter"
export default class extends Controller {
  static targets = ["issueDate", "dueDate", "dueDays", "dueDaysDiv"]

  initialize() {
    this.#returnIfDueDateNotPresent()
    if (this.issueDateTarget.value === "") {
      this.dueDaysDivTarget.classList.add("d-none")
    } else {
      const issue_date = new Date(this.issueDateTarget.value)
      const dueDate = new Date(this.dueDateTarget.value)
      this.dueDaysTarget.value = this.daysDifference(issue_date, dueDate)
    }
  }

  daysDifference(earlier_date, later_date) {
    earlier_date.setUTCHours(6, 1, 0, 0)
    later_date.setUTCHours(6, 1, 0, 0)
    return Math.ceil((later_date - earlier_date) / (1000 * 3600 * 24))
  }

  setDueDate(event) {
    this.#returnIfDueDateNotPresent()
    const issue_date = new Date(this.issueDateTarget.value)
    if (Number.isNaN(issue_date.getTime())) return

    if (event.target.id.includes("issue_date")) {
      const dueDays = parseInt(this.dueDaysTarget.value, 10) || 0
      const dueDate = new Date(issue_date)
      dueDate.setDate(issue_date.getDate() + dueDays)
      this.dueDateTarget.value = dueDate.toISOString().split("T")[0]
      this.dueDaysDivTarget.classList.remove("d-none")
      this.dueDaysTarget.value = this.daysDifference(issue_date, dueDate)
    } else if (event.target.id.includes("due_date")) {
      this.dueDaysTarget.value = this.datediff(
        this.parseDate(this.issueDateTarget.value),
        this.parseDate(this.dueDateTarget.value)
      )
    } else {
      const dueDays = parseInt(this.dueDaysTarget.value, 10)
      if (Number.isNaN(dueDays)) return
      const dueDate = new Date(issue_date)
      dueDate.setDate(issue_date.getDate() + dueDays)
      this.dueDateTarget.value = dueDate.toISOString().split("T")[0]
    }
  }

  /**
   * Take the difference between the dates and divide by milliseconds per day.
   * Round to nearest whole number to deal with DST.
   */
  datediff(first, second) {
    return Math.round((second - first) / (1000 * 60 * 60 * 24))
  }

  /**
   * new Date("dateString") is browser-dependent and discouraged, so we'll write
   * a simple parse function for U.S. date format (which does no error checking)
   */
  parseDate(str) {
    var mdy = str.split("-")
    return new Date(mdy[0], mdy[1] - 1, mdy[2])
  }

  #returnIfDueDateNotPresent() {
    if (!this.hasDueDateTarget) {
      return
    }
  }
}
